import { FC } from 'react'
import { Image } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import { close_icon, logo_icon } from 'src/assets'
import { APP_ENV, HEADER_LINK } from 'src/config'
import { TO_INTRO_S0 } from 'src/navigation'
import { header_t } from 'src/types'

const is_prd = APP_ENV === 'PRD'

export const Header: FC<header_t> = ({ on_close, progress, version }: header_t) => {
  const navigate = useNavigate()

  /**
   * Render functions
   */
  const render_logo = () => (
    <Image
      src={logo_icon}
      className="px-3 cursor-pointer"
      onClick={() => {
        if (is_prd) {
          window.open(HEADER_LINK)
        } else {
          navigate(TO_INTRO_S0)
        }
      }}
    />
  )

  const render_close = () => (
    <Image
      src={close_icon}
      className="p-4 border-left-1 cursor-pointer"
      onClick={on_close}
      role="button"
    />
  )

  const render_version = () => {
    return (
      !is_prd &&
      version && <p className="m-0 p-0 mr-4 d-xl-block d-none">{process.env.REACT_APP_VERSION}</p>
    )
  }

  return (
    <main className="iheader">
      <div className="border-1 d-flex align-items-center justify-content-between">
        {render_logo()}
        {render_version()}
        {render_close()}
      </div>
      <div className="progress" style={{ width: progress || 0 }} />
    </main>
  )
}
